// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39E9C","footer":"styles_footer__2U07s"};